import React, { Component } from 'react';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import Isvg from 'react-inlinesvg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";

/**
 * @author   Pantelija Simeunovic
 * Numeric text input
 * Supports int / decimal / double
 * Accepts , and . (comma is converted to dot)
 */
class NumericText extends Component {
    constructor(props) {
        super(props);
    }

    handleKeyPress = (e) => {
        const char = String.fromCharCode(e.which);
        if (!/[0-9.,]/.test(char)) {
            e.preventDefault();
            return false;
        }

        const value = e.target.value;
        if ((char === '.' || char === ',') && value.includes('.')) {
            e.preventDefault();
            return false;
        }
    };

    handleChange = (e) => {
        let value = e.target.value;
        value = value.replace(/,/g, '.');
        value = value.replace(/[^0-9.]/g, '');
        const parts = value.split('.');
        if (parts.length > 2) {
            value = parts[0] + '.' + parts.slice(1).join('');
        }

        e.target.value = value;
        this.props.onChange(e);
    };

    render() {
        const {
            label,
            labelInfo,
            value,
            name,
            placeholder,
            error,
            disabled,
            className,
            width,
            height
        } = this.props;

        return (
            <FormGroup className={className}>
                {label &&
                    <Label size="sm" className="form-group-label-wrap">
                        {label}
                        {labelInfo &&
                            <div className="info">
                                <Isvg src={infoIcon} />
                                <div className="info-text">{labelInfo}</div>
                            </div>
                        }
                    </Label>
                }

                <Input
                    type="text"
                    name={name}
                    value={value || ''}
                    placeholder={placeholder}
                    disabled={disabled}
                    invalid={!!error}
                    style={{
                        width: width || null,
                        height: height || null
                    }}
                    onKeyPress={this.handleKeyPress}
                    onChange={this.handleChange}
                    inputMode="decimal"
                />

                {error && <FormFeedback>{error}</FormFeedback>}
            </FormGroup>
        );
    }
}

export default NumericText;
